import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { BlueButton, GrayButton } from "../../styles/buttons";
import { OnlyLogo } from "../../styles/logos";
import { BoxTitle, BoxSubTitle, LeftBoxTitle, LeftBoxSubTitle } from "../../styles/texts";
import { InvisibleExternalBox, GrayBorderBox, InternalLeftBox, InternalCenterBox } from "../../styles/boxes";
import { LoginForm } from "../../styles/forms";

import validateLink from "./validateLink";
import validateCookie from "./validateCookie";

const ReceiveLink: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const contact = location.state?.contact;

  const [inputValue, setInputValue] = useState("");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    let validationResult = -1;
    let userData = null;
    const linkResponse = await validateLink(inputValue);

    if (linkResponse === 0) {
      const [user, validationResponse] = await validateCookie();
      userData = user;
      validationResult = validationResponse;
      const bookingIndex = 0;
      if (validationResult === 0) {
        navigate("/home", { state: { userData, bookingIndex } });
      }
      else {
        navigate("/selectmethod");
      }
    }
    else if (linkResponse === 1) {
      setErrorMessage("El link ingresado a expirado");
    }
    else if (linkResponse === 2) {
        setErrorMessage("El link ingresado no es válido");
    }
    else {
      setErrorMessage("Ocurrió un error inesperado. Por favor, intenta nuevamente");
    }
  };

  return (
    <InvisibleExternalBox w="434px" h="459px">
      <GrayBorderBox w="459px" h="388px">

        <OnlyLogo h="24px" />
        <BoxTitle>Iniciar Sesión</BoxTitle>
        <BoxSubTitle>Hemos enviado un link de acceso a tu contacto {contact}</BoxSubTitle>

        <form onSubmit={handleSubmit} className="flex flex-col items-center justify-center w-[395px]">
          <InternalCenterBox w="395px" h="115px" g="8px">
            <LoginForm
              method="link"
              onChange={(e) => setInputValue(e.target.value)}
              h="40px"
            />

            <BlueButton
              label="Iniciar Sesión"
              w="395px"
              h="44px"
              type="submit"
            />
          </InternalCenterBox>
        </form>

        {errorMessage && (
          <div className="text-red-500 mt-2">
            {errorMessage}
          </div>
        )}

        <InternalLeftBox w="395px" h="40px">
          <GrayButton
            label="Volver a Seleccionar método"
            onClick={() => navigate("/selectmethod")}
            h="32px"
          />
        </InternalLeftBox>
      </GrayBorderBox>

      <GrayBorderBox w="459px" h="157px">
        <InternalLeftBox w="395px" h="150px" g="8px">
          <LeftBoxTitle>¿No tienes cuenta?</LeftBoxTitle>
          <LeftBoxSubTitle>Primero debes iniciar un proceso de cotización.</LeftBoxSubTitle>
          <GrayButton
            label="Cotizar"
            onClick={() => window.open("https://ruuf.cl", "_blank")}
            w="89px"
            h="32px"
            icon="righthead"
          />
        </InternalLeftBox>
        
      </GrayBorderBox>

    </InvisibleExternalBox>
  );
};

export default ReceiveLink;